const EXTENSION_LOGOUT_EVENT = 'DEEPGUIDE_EXTENSION_LOGOUT';
const EXTENSION_LOGOUT_ACK_EVENT = 'DEEPGUIDE_EXTENSION_LOGOUT_ACK';
const EXTENSION_LOGOUT_TIMEOUT_MS = 1200;

/**
 * Best-effort sync: if the browser extension content script is present,
 * ask it to clear extension auth state as well. Never throw.
 */
export async function syncExtensionLogout(): Promise<void> {
  if (typeof window === 'undefined') return;

  await new Promise<void>((resolve) => {
    let settled = false;

    const done = () => {
      if (settled) return;
      settled = true;
      window.removeEventListener('message', onAck);
      clearTimeout(timeoutId);
      resolve();
    };

    const onAck = (event: MessageEvent) => {
      if (event.source !== window) return;
      if (event.data?.type !== EXTENSION_LOGOUT_ACK_EVENT) return;
      done();
    };

    const timeoutId = window.setTimeout(done, EXTENSION_LOGOUT_TIMEOUT_MS);
    window.addEventListener('message', onAck);

    window.postMessage({ type: EXTENSION_LOGOUT_EVENT }, '*');
  });
}
